/**
 * PascalCase page slug from English title — matches site convention (e.g. VisionMissionValues).
 */
export function titleToPageSlug(title = '') {
  return title
    .trim()
    .split(/[\s\-_/]+/)
    .filter(Boolean)
    .map((word) => {
      if (/^[A-Z0-9]{2,}$/.test(word)) {
        return word
      }

      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join('')
}
